import React, { Component } from 'react';
import ImgPrint from '../img/print.png';
import ImgPrintDetails from '../img/print_info.png';
import ImgSend from '../img/send.png';
import ImgExport from '../img/export.png';
import PropTypes from 'prop-types';
import CallApi from '../../../utils/CallApi';
import isSuiteAccount from './../../../utils/isSuiteAccount';
import moment from 'moment';
import groupBy from 'lodash/groupBy';
import getPaymentName from '../../../utils/getPaymentName';
import priceFormatting from '../../../utils/priceFormatting';
import LadditionLoader from '../../../components/LadditionLoader';
import PenSvg from '../svg/PenSvg';
import CheckSvg from '../svg/CheckSvg';
import { connect } from 'react-redux';
import decode from 'jwt-decode';
import { CSSTransition } from 'react-transition-group';
import { addFlashMessage } from '../../../common/flashMessage/actions/flashMessages';
import { I18n } from 'react-redux-i18n';
import insertVarInTxt from '../../../utils/InsertVarInText';
import { getRefreshToken } from '../../../utils/utils';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const isValidEmail = email => EMAIL_REGEX.test(email || '');

// Les fiches clients saisies en caisse contiennent des backticks et des
// guillemets typographiques (`AUGIER`, Au`thomas`tisme). On les ramene a une
// apostrophe droite pour l'affichage, et on les retire completement des noms de
// fichiers : un PDF nomme avec un backtick est ensuite servi en statique puis
// attache au mail.
const QUOTE_CHARS = /[`\u00b4\u2018\u2019\u201a\u201b\u2032\u201c\u201d\u2033]/g;

const normalizeQuotes = value => (value || '').replace(QUOTE_CHARS, "'");

const buildPdfName = (lastName, firstName) => {
	const keepAlphaNum = value => (value || '').replace(/[^A-Z0-9]/gi, '');
	const last = keepAlphaNum(lastName);
	const first = keepAlphaNum(firstName);
	return `${last}${first ? `-${first}` : ''}`;
};

// unique suffix per instance so the switch labels (htmlFor/id) don't collide when
// two CustomerNotesDetails are mounted at once (e.g. the detail-view side panel + the
// billing-history "Aperçu du ticket" modal).
let cndInstanceCounter = 0;

class CustomerNoteDetails extends Component {
	constructor(props) {
		super(props);
		this.uid = ++cndInstanceCounter;
		const refreshToken = getRefreshToken();
		this.state = {
			// L+ Suite : version de caisse 2.x ou plus, demandée au serveur.
			isSuite: false,
			linkPDF: '',
			listPaymentIds: props.listPaymentIds,
			actionPdfSelected: 'details',
			oldPdfSelected: '',
			errorPdf: false,
			disablePopup: false,
			userMail: decode(refreshToken).username
				? decode(refreshToken).username
				: '',
			msgContent: '',
			messageTemplate: '',
			subject: `${I18n.t('customerAccount.yourBill')}`,
			resSend: '',
			labelWithoutDetails: `${I18n.t('customerAccount.labelDetailsDefault')}`,
			// Quantité (entier >= 0). Vide par défaut = pas de préfixe (libellé seul) ;
			// toute saisie (y compris 1) est préfixée au libellé envoyé au WS.
			quantity: '',
			saveLabel: false,
			updateLabel: false,
			filter: props.filter,
			creditDetails: props.creditDetails,
			paymentTypes: props.paymentTypes,
			language: props.language,
			loading: false,
			renderPdf: false,
			emptyList: false,
			nameFileToDisplay: '',
			// restored from a billing-history row on re-send (default false, incl. old JSON)
			formatA4: props.initialFormatA4 || false,
			dayByDay: props.initialDayByDay || false,
			dayByDayEmail: props.initialDayByDayEmail || false,
			sendSeparateNote: props.initialSendSeparateNote || false,
			selectedCompany: props.selectedCompany,
			customerId: props.customerId,
			customerFirstName: props.customerFirstName,
			customerLastName: props.customerLastName,
			customerEmail: props.customerEmail,
			companies: props.companies,
			dataNotes: props.dataNotes,
		};
		this.messageTemplateRef = React.createRef();
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.listPaymentIds !== this.state.listPaymentIds ||
			nextProps.filter !== this.state.filter ||
			nextProps.creditDetails.timestamp !==
				this.state.creditDetails.timestamp ||
			nextProps.paymentTypes !== this.state.paymentTypes ||
			nextProps.emptyList !== this.state.emptyList ||
			nextProps.companies !== this.state.companies ||
			nextProps.dataNotes !== this.state.dataNotes
		) {
			this.setState(
				{
					listPaymentIds: nextProps.listPaymentIds,
					creditDetails: nextProps.creditDetails,
					paymentTypes: nextProps.paymentTypes,
					linkPDF: '',
					emptyList: nextProps.emptyList,
					filter: nextProps.filter,
					companies: nextProps.companies,
					dataNotes: nextProps.dataNotes,
				},
				() => {
					if (
						(!nextProps.emptyList &&
							nextProps.listPaymentIds.length &&
							(this.state.actionPdfSelected !== 'send' ||
								this.nextProps.filter !== 'credits')) ||
						this.state.listPaymentIds.length > 0
					) {
						this.getPDF();
					}
				}
			);
		}
		if (
			nextProps.customerId !== this.state.customerId ||
			nextProps.customerLastName !== this.state.customerLastName ||
			nextProps.customerFirstName !== this.state.customerFirstName ||
			nextProps.customerEmail !== this.state.customerEmail ||
			nextProps.selectedCompany !== this.state.selectedCompany
		) {
			this.setState({
				customerId: nextProps.customerId,
				customerFirstName: nextProps.customerFirstName,
				customerLastName: nextProps.customerLastName,
				customerEmail: nextProps.customerEmail,
				selectedCompany: nextProps.selectedCompany,
				linkPDF: '',
			});
			this.noteIsSelected();
		}
		if (nextProps.listPaymentIds !== this.state.listPaymentIds) {
			this.setState({
				actionPdfSelected:
					this.state.actionPdfSelected === 'send'
						? 'details'
						: this.state.actionPdfSelected,
				linkPDF: '',
				loading: false,
			});
			this.noteIsSelected();
		}

		return null;
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			this.state.listPaymentIds.length &&
			((prevState.saveLabel !== this.state.saveLabel && this.state.saveLabel) ||
				prevState.formatA4 !== this.state.formatA4 ||
				prevState.dayByDay !== this.state.dayByDay)
		) {
			this.getPDF();
		}

		if (prevState.actionPdfSelected !== this.state.actionPdfSelected) {
			if (
				this.state.actionPdfSelected === 'details' ||
				this.state.actionPdfSelected === 'withoutDetails'
			) {
				this.getPDF();
			}
		}

		const shouldUpdateMsgPreviewMsg =
			prevState.customerId !== this.state.customerId ||
			prevState.customerFirstName !== this.state.customerFirstName ||
			prevState.customerLastName !== this.state.customerLastName ||
			prevState.selectedCompany !== this.state.selectedCompany ||
			prevState.messageTemplate !== this.state.messageTemplate ||
			prevState.companies !== this.state.companies ||
			prevState.listPaymentIds !== this.state.listPaymentIds ||
			(
				prevState.actionPdfSelected !== this.state.actionPdfSelected &&
				this.state.actionPdfSelected === 'send'
			);

		if (shouldUpdateMsgPreviewMsg) {
			this.updateMessagePreview();
		}

		if (prevState.linkPDF !== this.state.linkPDF) {
			this.props.onUpdateLinkPdf(this.state.linkPDF);
		}

		if (
			prevState.listPaymentIds !== this.state.listPaymentIds &&
			this.state.listPaymentIds.length
		) {
			this.setState({
				resSend: '',
			});
			this.props.onUpdateGenerationPdf(false);
		}
	}

	async componentDidMount() {
		isSuiteAccount().then(isSuite => this.setState({ isSuite }));
		this.noteIsSelected();

		// when mounted already carrying a selection (e.g. reopened from the billing
		// history), generate the PDF right away — componentWillReceiveProps only fires
		// on prop changes, not on the initial mount.
		if (this.state.listPaymentIds && this.state.listPaymentIds.length) {
			this.getPDF();
		}

		try {
			const res = await CallApi(
				'GET',
				'customer-account/getVariablesServer',
				'',
				{
					keys: ['ticket_sending_msg'],
				}
			);
			this.setState(
				{
					messageTemplate: res[0].ticket_sending_msg || I18n.t('customerAccount.defaultTicketSendingMsg'),
				},
			);
    } catch (error) {
			console.error('Error retrieving user options:', error);
    }
	}

	updateMessagePreview = (template = this.state.messageTemplate) => {
		const {
			customerFirstName,
			customerLastName,
			companies,
			listPaymentIds,
		} = this.state;

		const listCompaniesPayment = groupBy(listPaymentIds, 'userDb');
		const listTmp = [];
		Object.keys(listCompaniesPayment).map(userDb => {
			return companies.filter(company =>
				company.company_db_name === userDb.toString()
					? listTmp.push(company.company_name)
					: ''
			);
		});

		const variables = {
			customerFirstName: normalizeQuotes(customerFirstName),
			customerLastName: normalizeQuotes(customerLastName),
			company: listTmp.join(`${I18n.t('customerAccount.and')}`),
		};

		const result = this.replaceVariables(template, variables);

		this.setState({
			msgContent: result,
		});
	};

	noteIsSelected = () => {
		let testCheck;
		const checkboxes = window.document.querySelectorAll("input[name='ticket']");
		const ListInputTmp = Array.prototype.slice.call(checkboxes);
		testCheck = ListInputTmp.some(input => input.checked === true);
		if (!testCheck) {
			this.setState({
				//	listPaymentIds: [],
				//emptyList: true,
				linkPDF: '',
			});
		}
	};

	getPDF = async () => {
		const [...listPaymentIds] = this.state.listPaymentIds;

		const {
			actionPdfSelected,
			labelWithoutDetails,
			quantity,
			customerFirstName,
			customerLastName,
			formatA4,
			dayByDay,
		} = this.state;
		const groupedPaymentsList = groupBy(listPaymentIds, 'customerId');

		// Champ vide -> libellé seul ; toute saisie (y compris 1) est préfixée.
		const label =
			quantity === ''
				? labelWithoutDetails
				: `${parseInt(quantity, 10)} ${labelWithoutDetails}`;
		const userName = buildPdfName(customerLastName, customerFirstName);

		if (groupedPaymentsList && Object.keys(groupedPaymentsList).length) {
			try {
				this.setState(
					{
						loading: true,
						linkPDF: '',
						renderPdf: false,
					},
					() => {}
				);
				this.props.onUpdateGenerationPdf(true);
				const urlPDF = await CallApi(
					'POST',
					`customer-account/notes/${actionPdfSelected}`,
					'',
					{ groupedPaymentsList, label, userName, formatA4, dayByDay }
				);
				const result = urlPDF[0][0];

				this.setState(
					{
						linkPDF: result ? result.url.toString() : [],
						nameFileToDisplay: result ? result.nameFile : '',
						errorPdf: result.url.length > 0 ? false : true,
						saveLabel: false,
					},
					() => {
						if (this.state.linkPDF.length > 0) {
							setTimeout(() => {
								this.setState({
									renderPdf: true,
									loading: false,
								});
							}, 500);
						}
					}
				);
			} catch (e) {
				this.props.addFlashMessage({
					type: 'danger',
					text: I18n.t('accountMigration.error'),
					persistent: false,
				});
			}
		}
	};

	replaceVariables = (template, variables) => {
		let result = template || '';

		Object.entries(variables).forEach(([key, value]) => {
        result = result.replaceAll(`{{${key}}}`, value ?? '');
    });

		return result;
	};

	submitForm = async e => {
		e.preventDefault();
		if (!isValidEmail(this.state.customerEmail)) {
			this.setState({
				resSend: I18n.t('customerAccount.invalidEmailError'),
			});
			return;
		}
		const {
			userMail,
			customerEmail,
			msgContent,
			messageTemplate,
			subject,
			nameFileToDisplay,
			formatA4,
			dayByDay,
			dayByDayEmail,
			listPaymentIds,
			sendSeparateNote,
			labelWithoutDetails,
			customerId,
			customerFirstName,
			customerLastName,
			oldPdfSelected,
			dataNotes,
		} = this.state;

		const userName = buildPdfName(customerLastName, customerFirstName);

		let sendSucceeded = false;
		try {
			this.setState({
				loading: true,
			});

			const postForm = await CallApi(
				'POST',
				'customer-account/notes/send',
				'',
				{
					userMail,
					customerEmail,
					subject,
					msgContent,
					messageTemplate,
					nameFileToDisplay,
					listPaymentIds,
					formatA4,
					dayByDayEmail,
					sendSeparateNote,
					userName,
					oldPdfSelected,
					labelWithoutDetails,
				}
			);
			sendSucceeded = !!(postForm[0] && postForm[0].message === 'success');

			if (messageTemplate) {
				await CallApi(
					'PUT',
					'customer-account/upsertVariableServer',
					'',
					{
						key: 'ticket_sending_msg',
						value: messageTemplate,
					}
				);
			}
		} catch (e) {
			this.props.addFlashMessage({
				type: 'danger',
				text: I18n.t('accountMigration.error'),
				persistent: false,
			});
		}

		// Hors du try ci-dessus : l'historique doit etre ecrit meme si l'envoi ou la
		// sauvegarde du gabarit a echoue. C'est ce qui faisait disparaitre la ligne
		// sans le moindre log cote serveur, la requete n'etant jamais emise.
		await this.recordInvoiceEmail();

		this.setState({
			loading: false,
			resSend: sendSucceeded
				? I18n.t('customerAccount.ticketSendCorrectly')
				: I18n.t('customerAccount.sendMailError'),
		});
	};

	// Ecrit la ligne d'historique dans customer_account_invoicing.
	recordInvoiceEmail = async () => {
		const {
			listPaymentIds,
			dataNotes,
			customerId,
			customerFirstName,
			customerLastName,
			customerEmail,
			formatA4,
			dayByDay,
			sendSeparateNote,
			dayByDayEmail,
		} = this.state;

		const selectedIds = listPaymentIds.map(payment => payment.idPayment);
		if (!selectedIds.length || !customerId) return;

		const allNotes = Object.values(dataNotes || {}).flatMap(customer =>
			Object.values(customer.details || {}).flat()
		);
		const selectedNotes = allNotes.filter(note =>
			selectedIds.includes(note.payment_line_id)
		);

		const sentTimestamp = Math.floor(Date.now() / 1000);

		// Renvoi depuis l'historique : ModalEmails monte le composant avec
		// dataNotes={{}}, donc selectedNotes est vide. On reprend le montant et la
		// date de la ligne d'origine au lieu d'abandonner l'ecriture en silence.
		const amount = selectedNotes.length
			? selectedNotes.reduce((sum, note) => sum + Number(note.amount || 0), 0)
			: Number(this.props.resendAmount || 0);

		const lastInvoiceTimestamp = selectedNotes.length
			? selectedNotes.reduce((latest, current) =>
					Number(current.timestamp) > Number(latest.timestamp)
						? current
						: latest
			  ).timestamp
			: this.props.resendInvoiceTimestamp;

		const payload = {
			sent_timestamp: sentTimestamp,
			// colonne NOT NULL : on retombe sur la date d'envoi plutot que d'envoyer
			// un undefined, que knex refuse a la compilation de l'INSERT.
			last_invoice_timestamp: Number(lastInvoiceTimestamp) || sentTimestamp,
			id_contact: customerId,
			firstname: customerFirstName || '',
			lastname: customerLastName || '',
			email: customerEmail || '',
			amount,
			status: 'sent',
			data: JSON.stringify({
				ids: selectedIds,
				// button/toggle states at send time, to restore the same view on row click later
				formatA4,          // preview "Format A4"
				dayByDay,          // preview "Jour par jour"
				sendSeparateNote,  // send "Envoyer chaque ticket en tant que PDF separe"
				dayByDayEmail,     // send "Jour par jour" (distinct from the preview one)
			}),
		};

		try {
			await CallApi(
				'PUT',
				'customer-account/insertInvoiceEmail',
				'',
				payload
			);
		} catch (e) {
			// l'echec etait muet : la ligne manquait sans que personne ne le voie
			console.error('insertInvoiceEmail failed:', e);
			this.props.addFlashMessage({
				type: 'danger',
				text: I18n.t('customerAccount.invoiceEmailNotRecorded'),
				persistent: false,
			});
		}
	};

	handleActionPDF = (e, action) => {
		e.preventDefault();
		if (action !== this.state.actionPdfSelected) {
			this.setState({
				actionPdfSelected: action,
				resSend: '',
				saveLabel: false,
				oldPdfSelected: this.state.actionPdfSelected,
			});
		}
	};

	handleExport = e => {
		e.preventDefault();
		const link = window.document.createElement('a');
		link.target = '_BLANK';
		link.href = this.state.linkPDF;
		link.setAttribute('download', 'ticket.pdf');
		window.document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	handlePopup = (e, bool) => {
		e.preventDefault();
		this.setState({
			disablePopup: bool,
		});
	};

	resetEmail = e => {
		e.preventDefault();
		this.setState({
			resSend: '',
		});
	};

	handleLabelWithoutDetails = e => {
		e.preventDefault();
		this.setState({
			labelWithoutDetails: e.target.value,
			saveLabel: false,
		});
	};

	handleQuantity = e => {
		this.setState({
			quantity: e.target.value.replace(/[^0-9]/g, ''),
			saveLabel: false,
		});
	};

	handleLabel = e => {
		e.preventDefault();
		this.setState({
			updateLabel: true,
		});
	};

	saveLabel = e => {
		e.preventDefault();
		this.setState({
			saveLabel: true,
			updateLabel: false,
		});
	};

	handleFormatPdf = e => {
		//e.preventDefault();
		this.setState({
			formatA4: !this.state.formatA4,
		});
	};

	handleDayByDayPdf = e => {
		this.setState({
			dayByDay: !this.state.dayByDay,
		});
	};

	handleDayByDayEmailPdf = e => {
		this.setState({
			dayByDayEmail: !this.state.dayByDayEmail,
		});
	};

	handleOptionEmail = e => {
		this.setState({
			sendSeparateNote: !this.state.sendSeparateNote,
		});
	};

	handleFormSend = e => {
		const { name, value } = e.target;

		this.setState(
			{
				[name]: value,
			},
			() => {
				if (name === 'messageTemplate') {
					this.updateMessagePreview(value);
				}
			}
		);
	};

	handleInsertVar = (key) => {
		const input = this.messageTemplateRef.current;

		insertVarInTxt({
			input,
			value: this.state.messageTemplate || '',
			key,
			onChange: (newValue) => {
				this.setState({
					messageTemplate: newValue,
				});
			},
			onAfterChange: (newValue) => {
				this.updateMessagePreview(newValue);
			},
		})
	};

	render() {
		const {
			linkPDF,
			actionPdfSelected,
			listPaymentIds,
			userMail,
			customerEmail,
			msgContent,
			messageTemplate,
			subject,
			resSend,
			filter,
			loading,
			labelWithoutDetails,
			quantity,
			paymentTypes,
			saveLabel,
			errorPdf,
			renderPdf,
			emptyList,
			language,
			updateLabel,
			oldPdfSelected,
			formatA4,
			sendSeparateNote,
			dayByDay,
			dayByDayEmail,
		} = this.state;

		const msgFields = [
			{ label: I18n.t('customerAccount.firstname'), key: "customerFirstName" },
			{ label: I18n.t('customerAccount.name'), key: "customerLastName" },
			{ label: I18n.t('customerAccount.companyName'), key: "company" },
		];

		const renderEmailForm = userMailSender => {
			return (
				<CSSTransition
					classNames="displayForm"
					timeout={350}
					in={
						actionPdfSelected === 'send' && linkPDF && !resSend && !loading
							? true
							: false
					}>
					<form
						noValidate
						ref={this.form}
						onSubmit={this.submitForm}
						id="form-email"
					>
						<label>
							<p>{`${I18n.t('customerAccount.mailSender')}* :`}</p>{' '}
							<input
								type="email"
								name="userMail"
								className="input"
								className={(userMailSender ? '' : 'empty', 'input')}
								value={userMail}
								onChange={this.handleFormSend}
							/>
						</label>
						<label>
							<p>{`${I18n.t('customerAccount.mailRecipient')}* :`}</p>{' '}
							<input
								type="email"
								name="customerEmail"
								value={customerEmail}
								className={customerEmail ? '' : 'empty input'}
								onChange={this.handleFormSend}
							/>
							{customerEmail && !isValidEmail(customerEmail) && (
								<p style={{ color: '#e84249', fontSize: 12, margin: '4px 0 0' }}>
									{I18n.t('customerAccount.invalidEmailError')}
								</p>
							)}
						</label>
						<label>
							<p>{`${I18n.t('customerAccount.mailSubject')}* :`}</p>{' '}
							<input
								type="text"
								name="subject"
								value={subject}
								className={subject ? '' : 'empty input'}
								onChange={this.handleFormSend}
							/>
						</label>
						<label>
							<p>{`${I18n.t('customerAccount.msgTemplate')}* :`}</p>{' '}
							<div className="msg-template">
								<textarea
									ref={this.messageTemplateRef}
									name="messageTemplate"
									value={messageTemplate || ''}
									className={messageTemplate ? '' : 'empty input'}
									onChange={this.handleFormSend}
								/>
								<div className="flex flex-row gap-2 items-center">
									{msgFields.map((el) => (
										<button
											key={el.key}
											type="button"
											className="field-btn text-lg"
											onMouseDown={(e) => {
												e.preventDefault();
												this.handleInsertVar(el.key);
											}}
										>
											{el.label}
										</button>
									))}
								</div>
							</div>
						</label>
						<label>
							<p>{`${I18n.t('customerAccount.msgPreview')} :`}</p>{' '}
							<div className='msg-preview'>{msgContent}</div>
						</label>
						<p className="attachment">
							{`${I18n.t('customerAccount.mailAttachement')} :`}{' '}
							{sendSeparateNote ? `${listPaymentIds.length}` : `1`} ticket(s){' '}
							{oldPdfSelected === 'details'
								? I18n.t('customerAccount.ticketDetailsMultiple')
								: I18n.t('customerAccount.ticketNoDetailsMultiple')}{' '}
							{formatA4 ? I18n.t('customerAccount.toPageFormat') : ''}
						</p>

						<button
							disabled={
								!(userMailSender && customerEmail && msgContent && isValidEmail(customerEmail))
							}
							className={
								userMailSender && customerEmail && msgContent && isValidEmail(customerEmail)
									? 'send-btn'
									: 'send-btn disabled'
							}
							style={
								userMailSender && customerEmail && msgContent && isValidEmail(customerEmail)
									? {}
									: { background: '#ccc', color: '#fff', cursor: 'not-allowed', boxShadow: 'none' }
							}>
							{I18n.t('customerAccount.ticketSend')}
						</button>
					</form>
				</CSSTransition>
			);
		};

		const renderPreview = () => {
			if (emptyList) {
				return (
					<div className="center-p">
						<p>{I18n.t('customerAccount.noTicketSelected')}</p>
					</div>
				);
			} else {
				if (listPaymentIds.length) {
					if (
						(renderPdf &&
							linkPDF &&
							actionPdfSelected !== 'send' &&
							!errorPdf &&
							actionPdfSelected !== 'withoutDetails') ||
						(renderPdf &&
							linkPDF &&
							actionPdfSelected !== 'send' &&
							!errorPdf &&
							actionPdfSelected === 'withoutDetails')
					) {
						return (
							<React.Fragment>
								<embed src={linkPDF} type="application/pdf" />
							</React.Fragment>
						);
					}
					if (actionPdfSelected === 'send' && linkPDF && !resSend && !loading) {
						const userMailSender = userMail;
						return renderEmailForm(userMailSender);
					}
					if (resSend && linkPDF) {
						return (
							<CSSTransition
								classNames="resEmail"
								timeout={450}
								in={resSend.length ? true : false}>
								<div className="new-mail">
									<p>{resSend}</p>
									{/*  <button onClick={this.resetEmail}>
                    Envoyer un nouveau mail
                  </button> */}
								</div>
							</CSSTransition>
						);
					}
					if (loading) {
						return (
							<div className="loader">
								<LadditionLoader hidden={!this.state.loading} />
							</div>
						);
					}
					return (
						<div className="center-p">
							<p>{I18n.t('customerAccount.errorTicketGeneration')}</p>
						</div>
					);
				} else {
					return (
						<p className="center-p">
							{I18n.t('customerAccount.noTicketSelected')}
						</p>
					);
				}
			}
		};

		const renderCreditDetails = () => {
			const { creditDetails, emptyList } = this.state;
			if (
				creditDetails &&
				creditDetails.infos &&
				creditDetails.userDb &&
				!this.state.emptyList
			) {
				if (creditDetails.infos.length > 0) {
					const creditTs = moment
						.unix(creditDetails.timestamp)
						.format('DD/MM/YYYY - HH:mm');
					return (
						<div className="credit-details">
							<p>{creditTs}</p>
							<p className="title-credit">
								{I18n.t('customerAccount.oneCredit')}{' '}
								{paymentTypes &&
								paymentTypes.length > 1 &&
								creditDetails.id_payment_type
									? ` ${getPaymentName(
											paymentTypes,
											creditDetails.id_payment_type
									  )}`
									: ''}
								<span>
									{priceFormatting(creditDetails.amount, language, 'EUR')}
								</span>
							</p>
							{creditDetails.infos.map((tickets, i) => {
								const ticketTs = moment
									.unix(tickets.timestamp)
									.format('DD/MM/YYYY - HH:mm');
								return (
									<div className="credit-note-paid" key={`credit-${i}`}>
										<p className="credit-user" key={`credit-p-${i}`}>
											{tickets && tickets.user_lastname
												? tickets.user_lastname
												: ''}{' '}
											{tickets && tickets.user_firstname
												? tickets.user_firstname
												: ''}
										</p>
										<p>
											{I18n.t('customerAccount.onTicket')} {ticketTs} (
											{tickets && tickets.payment_name
												? `${tickets.payment_name} `
												: ''}
											){' '}
											<span className="amount">
												{tickets && tickets.amount
													? priceFormatting(tickets.amount, language, 'EUR')
													: ''}
											</span>
										</p>
										<p>
											{I18n.t('customerAccount.amountUsed')}
											<span className="amount">
												{tickets && tickets.amount_paid
													? priceFormatting(
															tickets.amount_paid,
															language,
															'EUR'
													  )
													: ''}
											</span>
										</p>
									</div>
								);
							})}
						</div>
					);
				} else {
					return (
						<p className="center-p">
							{I18n.t('customerAccount.noPaymentLine')}
						</p>
					);
				}
			} else if (creditDetails.userDb && creditDetails.infos === 0) {
			} else if (!emptyList && !creditDetails) {
				return (
					<p className="center-p">
						{I18n.t('customerAccount.creditLoadDataError')}
					</p>
				);
			} else if (emptyList) {
				return (
					<p className="center-p">{I18n.t('customerAccount.noFoundCredit')}</p>
				);
			} else {
				return (
					<p className="center-p">
						{I18n.t('customerAccount.selectOneCredit')}
					</p>
				);
			}
		};

		const renderOptionPdf = filter => {
			return (
				<div className="action-pdf">
					<div className="flex justify-between">
						<div className="format-pdf" onChange={this.handleFormatPdf}>
							<input
								className="checkbox"
								id={`checkbox1-${this.uid}`}
								type="checkbox"
								checked={formatA4}
								readOnly={true}
							/>
							<label htmlFor={`checkbox1-${this.uid}`} className="checkbox-label switch">
								<span className="on">
									{I18n.t('customerAccount.pageFormat')}
								</span>
								<span className="off">
									{I18n.t('customerAccount.pageFormat')}
								</span>
							</label>
						</div>
						<div className="day-by-day-pdf" onChange={this.handleDayByDayPdf}>
							<input
								className="checkbox"
								id={`checkbox2-${this.uid}`}
								type="checkbox"
								checked={dayByDay}
								readOnly={true}
							/>
							<label htmlFor={`checkbox2-${this.uid}`} className="checkbox-label switch">
								<span className="on">
									{I18n.t('customerAccount.dayByDay')}
								</span>
								<span className="off">
									{I18n.t('customerAccount.dayByDay')}
								</span>
							</label>
						</div>
					</div>
					{actionPdfSelected === 'withoutDetails' ? (
						<div className="label-withoutDetails">
							<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
							<p className={updateLabel ? 'form' : ''}>
								<span>{I18n.t('customerAccount.defaultLabel')}</span>{' '}
								{!!updateLabel && !saveLabel ? (
									<React.Fragment>
										<input
											type="number"
											min={0}
											placeholder="1"
											value={quantity}
											onChange={this.handleQuantity}
											style={{ width: '56px', marginRight: '6px' }}
										/>
										<input
											value={labelWithoutDetails}
											onChange={this.handleLabelWithoutDetails}
										/>
										<span onClick={e => this.saveLabel(e)} className="btn">
											<CheckSvg />
										</span>
									</React.Fragment>
								) : (
									<React.Fragment>
										<span>
											{quantity === ''
												? labelWithoutDetails
												: `${parseInt(quantity, 10)} ${labelWithoutDetails}`}
										</span>
										<span
											className="btn pen"
											title={I18n.t('customerAccount.editLabelQtyHint')}
											onClick={e => this.handleLabel(e)}>
											<PenSvg />
										</span>
									</React.Fragment>
								)}{' '}
							</p>
							<p
								className="label-qty-hint"
								style={{
									fontSize: '11px',
									color: '#8a8a8a',
									fontStyle: 'italic',
									margin: '2px 0 0',
								}}>
								✏️ {I18n.t('customerAccount.editLabelQtyHint')}
							</p>
							</div>
						</div>
					) : (
						''
					)}
				</div>
			);
		};

		const renderOptionMail = () => {
			return (
				<div className="action-pdf">
					<div className="flex-col">
						<div className="email-option" onChange={this.handleOptionEmail}>
							<input
								className="checkbox"
								id={`emailOption-${this.uid}`}
								type="checkbox"
								onChange={() => console.log('Checked')}
								checked={sendSeparateNote}
								disabled={dayByDayEmail ? true : false}
							/>
							<label htmlFor={`emailOption-${this.uid}`} className="checkbox-label switch">
								<span className="on">
									{I18n.t('customerAccount.sendTicketPDF')}
								</span>
								<span className="off">
									{I18n.t('customerAccount.sendTicketPDF')}
								</span>
							</label>
						</div>
						{!this.state.sendSeparateNote && this.state.isSuite && (
							<div
								className="day-by-day-pdf"
								onChange={this.handleDayByDayEmailPdf}>
								<input
									className="checkbox"
									id={`checkbox3-${this.uid}`}
									type="checkbox"
									checked={dayByDayEmail}
									readOnly={true}
								/>
								<label htmlFor={`checkbox3-${this.uid}`} className="checkbox-label switch">
									<span className="on">
										{I18n.t('customerAccount.dayByDay')}
									</span>
									<span className="off">
										{I18n.t('customerAccount.dayByDay')}
									</span>
								</label>
							</div>
						)}
					</div>
				</div>
			);
		};

		return (
			<React.Fragment>
				{filter !== 'credits' ? (
					<div className="bloc">
						<div
							className={`${
								filter !== 'credits' /* && !emptyList */
									? 'cta-enable'
									: 'cta-action-disabled'
							} cta-action `}
							onClick={e => this.handleActionPDF(e, 'details')}>
							<div
								className={actionPdfSelected === 'details' ? 'selected' : ''}>
								<div>
									<img src={ImgPrintDetails} alt="print info" />
								</div>
								<p> {I18n.t('customerAccount.ticketDetails')}</p>
							</div>
						</div>
						<div
							className={`${
								filter !== 'credits' /* && !emptyList */
									? 'cta-enable'
									: 'cta-action-disabled'
							} cta-action `}
							onClick={e => this.handleActionPDF(e, 'withoutDetails')}>
							<div
								className={
									actionPdfSelected === 'withoutDetails' ? 'selected' : ''
								}>
								<div>
									<img src={ImgPrint} alt="print" />
								</div>
								<p> {I18n.t('customerAccount.ticketNoDetails')}</p>
							</div>
						</div>

						<div
							className={`${
								listPaymentIds &&
								listPaymentIds.length > 0 &&
								linkPDF &&
								linkPDF.length
									? 'cta-enable'
									: 'cta-action-disabled'
							} cta-action`}
							onClick={e => this.handleActionPDF(e, 'send')}>
							<div className={actionPdfSelected === 'send' ? 'selected' : ''}>
								<div>
									<img src={ImgSend} />
								</div>
								<p> {this.props.isResend ? I18n.t('customerAccount.ticketResend') : I18n.t('customerAccount.ticketSend')}</p>
							</div>
						</div>
					</div>
				) : null}
				<div className="preview">
					{filter !== 'credits' &&
					!loading &&
					(actionPdfSelected === 'details' ||
						actionPdfSelected === 'withoutDetails')
						? renderOptionPdf(filter)
						: ''}
					{actionPdfSelected === 'send' && !emptyList && !loading && !resSend
						? renderOptionMail()
						: ''}
					{filter === 'credits' ? renderCreditDetails() : renderPreview()}
					<CSSTransition
						classNames="resEmail-enter"
						timeout={700}
						in={
							actionPdfSelected !== 'send' && linkPDF && listPaymentIds
								? true
								: false
						}>
						<div
							id="export"
							className={`${
								listPaymentIds &&
								listPaymentIds.length > 0 &&
								linkPDF &&
								linkPDF.length &&
								actionPdfSelected !== 'send'
									? 'cta-export'
									: 'cta-export-hide'
							}`}
							onClick={this.handleExport}>
							<div className="export-bloc">
								<img src={ImgExport} />
								<p>{I18n.t('customerAccount.export')}</p>
							</div>
						</div>
					</CSSTransition>
				</div>
			</React.Fragment>
		);
	}

	static defaultProps = {
		linkPDF: '',
		listPaymentIds: [],
		filter: '',
		creditDetails: {
			/*  amount: "0",
      id_payment_type: "",
      infos: [],
      timestamp: "0" */
		},
		paymentTypes: {},
		language: window.navigator.language,
		emptyList: false,
		selectedCompany: '',
		customerFirstName: '',
		customerLastName: '',
		customerEmail: '',
		companies: {
			amount: 0,
		},
	};
}

CustomerNoteDetails.propTypes = {
	linkPDF: PropTypes.string,
	listPaymentIds: PropTypes.array,
	filter: PropTypes.string,
	creditDetails: PropTypes.object,
	paymentTypes: PropTypes.object,
	language: PropTypes.array.isRequired,
	emptyList: PropTypes.bool.isRequired,
	selectedCompany: PropTypes.string,
	customerFirstName: PropTypes.string,
	// renvoi depuis l'historique : dataNotes est vide, ces deux valeurs
	// remplacent le montant et la date recalcules depuis les notes
	resendAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	resendInvoiceTimestamp: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	customerLastName: PropTypes.string,
	customerEmail: PropTypes.string,
	companies: PropTypes.array.isRequired,
	onUpdateLinkPdf: PropTypes.func.isRequired,
	onUpdateGenerationPdf: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
	const user = state.auth.user;

	return {
		auth: state.auth,
	};
}

export default connect(mapStateToProps, { addFlashMessage })(
	CustomerNoteDetails
);
